import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { AuditTrailDownloadRequestDto } from '../../../../backend/src/auditTrail/dto/auditTrail-download.request.dto';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDownloadAuditTrail = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadAuditTrail = async ({
    format,
    title,
    columns,
    searchQuery,
    startDate,
    endDate,
    matterId,
    userId,
    auditEventType,
  }: AuditTrailDownloadRequestDto) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        format,
        title,
        columns,
        searchQuery,
        startDate,
        endDate,
        matterId,
        userId,
        auditEventType,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/auditTrail/download`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to download audit trail');
    }

    const blob = await response.blob();

    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: `${title}.${format}`,
    });

    link.click();

    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading: isLoadingDownload } = useMutation(downloadAuditTrail, {
    onError: () => {
      toast.error('Failed to download audit trail. Please try again.');
    },
  });

  return { fetchDownload, isLoadingDownload };
};
